var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { BASE_BORDER_WIDTH, SPACING_XS, SPACING_S, SPACING_M, SPACING_L, SPACING_XL, FONT_SIZE_M, FONT_LINE_HEIGHT_M, BASE_FONT_NORMAL_WEIGHT, BASE_FONT_BOLD_WEIGHT, BASE_FONT_FAMILY, createUIElement } from "../helpers";
var config = {
    marginLeft: "-" + SPACING_S,
    marginRight: "-" + SPACING_S,
    marginBottom: SPACING_L,
    paddingBottomLastTd: SPACING_XS
};
var FieldsetTitle = function (_a) {
    var className = _a.className, title = _a.title;
    return (React.createElement("tr", { className: className },
        React.createElement("td", { colSpan: 3 },
            React.createElement("div", null, title))));
};
var FieldsetTitleStyle = styled(FieldsetTitle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    td {\n        padding: calc(", " - ", ") 0 ", ";\n    }\n\n    td > div {\n        padding-left: ", ";\n        font-weight: ", ";\n        line-height: ", ";\n        background-color: ", ";\n    }\n"], ["\n    td {\n        padding: calc(", " - ", ") 0 ", ";\n    }\n\n    td > div {\n        padding-left: ", ";\n        font-weight: ", ";\n        line-height: ", ";\n        background-color: ", ";\n    }\n"])), SPACING_M, config.paddingBottomLastTd, SPACING_M, SPACING_S, BASE_FONT_BOLD_WEIGHT, SPACING_XL, function (_a) {
    var theme = _a.theme;
    return theme.colorBackgroundNeutralLight;
});
var FieldsetSeparator = function (_a) {
    var className = _a.className;
    return (React.createElement(FieldsetTitle, { className: className }));
};
var FieldsetSeparatorStyle = styled(FieldsetSeparator)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    & > td {\n        padding: calc(", " - ", ") ", " 0;\n\n        ", "\n    }\n"], ["\n    & > td {\n        padding: calc(", " - ", ") ", " 0;\n\n        ",
    "\n    }\n"])), SPACING_M, config.paddingBottomLastTd, SPACING_S, function (_a) {
    var theme = _a.theme, hasBorder = _a.hasBorder;
    return hasBorder && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                & > div {\n                    padding-bottom: ", ";\n                    border-top: ", " solid ", ";\n                }\n            "], ["\n                & > div {\n                    padding-bottom: ", ";\n                    border-top: ", " solid ", ";\n                }\n            "])), SPACING_M, BASE_BORDER_WIDTH, theme.colorBorderMain);
});
function RowField(_a) {
    var className = _a.className, label = _a.label, value = _a.value, transform = _a.transform;
    return (React.createElement("tr", { className: className },
        React.createElement("td", null, label),
        React.createElement("td", null, transform ? transform(value) : value)));
}
var RowFieldStyle = styled(RowField)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    & > td {\n        padding: 0 ", " ", " 0;\n        font-weight: ", ";\n        line-height: ", ";\n        vertical-align: top;\n        word-break: break-all;\n\n        &:first-child {\n            padding-left: ", ";\n            width: ", ";\n            white-space: ", ";\n        }\n\n        &:last-child {\n            padding-right: ", ";\n        }\n    }\n\n    &:last-child > td {\n        padding-bottom: ", ";\n    }\n"], ["\n    & > td {\n        padding: 0 ", " ", " 0;\n        font-weight: ", ";\n        line-height: ", ";\n        vertical-align: top;\n        word-break: break-all;\n\n        &:first-child {\n            padding-left: ", ";\n            width: ", ";\n            white-space: ",
    ";\n        }\n\n        &:last-child {\n            padding-right: ", ";\n        }\n    }\n\n    &:last-child > td {\n        padding-bottom: ", ";\n    }\n"])), SPACING_XL, SPACING_S, BASE_FONT_NORMAL_WEIGHT, FONT_LINE_HEIGHT_M, SPACING_S, function (_a) {
    var labelWidth = _a.labelWidth;
    return (labelWidth === 'auto' ? '1%' : labelWidth);
}, function (_a) {
    var labelWidth = _a.labelWidth;
    return labelWidth === 'auto' ? 'nowrap' : 'normalGridRow';
}, SPACING_S, config.paddingBottomLastTd);
var FieldsetCustomBody = function (_a) {
    var render = _a.render;
    var StyledBodyRender = styled.tr(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        & td {\n            padding-left: ", ";\n        }\n    "], ["\n        & td {\n            padding-left: ", ";\n        }\n    "])), SPACING_S);
    var BodyRender = function () { return (React.createElement(StyledBodyRender, null,
        React.createElement("td", { colSpan: 3 }, render))); };
    return React.createElement(BodyRender, null);
};
function getFieldContents(labelWidth, fields) {
    return fields
        ? fields
            .map(function (_a, i) {
            var label = _a.label, value = _a.value, transform = _a.transform, hidden = _a.hidden;
            if (hidden) {
                return null;
            }
            return (React.createElement(RowFieldStyle, { key: "row-field " + i, label: label, value: value, transform: transform, labelWidth: labelWidth }));
        })
            .filter(function (content) { return content != null; })
        : [];
}
function Fieldset(_a) {
    var className = _a.className, title = _a.title, customBody = _a.customBody, fieldContents = _a.fieldContents, hasBorder = _a.hasBorder;
    return (React.createElement("tbody", { className: className },
        title ? (React.createElement(FieldsetTitleStyle, { title: title })) : (React.createElement(FieldsetSeparatorStyle, { hasBorder: hasBorder })),
        customBody && React.createElement(FieldsetCustomBody, { render: customBody }),
        fieldContents));
}
var FieldsetStyle = styled(Fieldset)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", ";\n    font-family: ", ";\n    color: ", ";\n\n    &:first-child ", " td {\n        padding-top: 0;\n    }\n"], ["\n    font-size: ", ";\n    font-family: ", ";\n    color: ", ";\n\n    &:first-child ", " td {\n        padding-top: 0;\n    }\n"])), FONT_SIZE_M, BASE_FONT_FAMILY, function (_a) {
    var theme = _a.theme;
    return theme.colorTextMain;
}, FieldsetTitleStyle);
var StyledTable = styled.table(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: calc(\n        100% +\n            ", "px\n    );\n    border-collapse: collapse;\n    margin-left: ", ";\n    margin-bottom: ", ";\n"], ["\n    width: calc(\n        100% +\n            ",
    "px\n    );\n    border-collapse: collapse;\n    margin-left: ", ";\n    margin-bottom: ", ";\n"])), Math.abs(parseInt(config.marginLeft, 10)) +
    Math.abs(parseInt(config.marginRight, 10)), config.marginLeft, config.marginBottom);
export var WizardSummary = createUIElement('WizardSummary', function (_a, ref) {
    var className = _a.className, _b = _a.labelWidth, labelWidth = _b === void 0 ? 'auto' : _b, fieldsets = _a.fieldsets, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "labelWidth", "fieldsets", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (React.createElement(StyledTable, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'wizard-summary', className: "vm-WizardSummary " + className, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), fieldsets &&
        fieldsets
            .map(function (fieldset) {
            var title = fieldset.title, fields = fieldset.fields, renderBody = fieldset.renderBody;
            var fieldContents = getFieldContents(labelWidth, fields);
            var isEmptyFragment = !title && !renderBody && fieldContents.length === 0;
            return (!isEmptyFragment && {
                title: title,
                fieldContents: fieldContents,
                renderBody: renderBody
            });
        })
            .filter(Boolean)
            .map(function (_a, idx) {
            var title = _a.title, fieldContents = _a.fieldContents, renderBody = _a.renderBody;
            return (React.createElement(Fragment, { key: "fieldset-" + idx },
                React.createElement(FieldsetStyle, { title: title, fieldContents: fieldContents, customBody: renderBody, hasBorder: !!idx })));
        })));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=WizardSummary.js.map